<template>
  <div class="formulario-solicitud-princ" data-app>
    <div class="div-titulo-seccion">
      <div class="row row-cols-lg-12">
        <div class="col-lg-8 columna-titulo">
          <p class="titulo-seccion-t">{{ this.NombreCompletoProspecto }}</p>
        </div>
        <div class="col-lg-4 columna-boton">
          <label
            class="label-guardar-progreso-t"
            @click.prevent="GuardarBorradorSolicitud()"
            v-if="seccionActual != 5 && soloLectura == false"
            >Save progress</label
          >
        </div>
      </div>
    </div>
    <div class="container contenedor">
      <stepper-movil
        :pasos="this.pasos"
        :pasoActual="this.seccionActual"
      ></stepper-movil>
      <stepper :pasos="this.pasos" :pasoActual="this.seccionActual"></stepper>
      <div ref="seccion-1" v-show="seccionActual == 1">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioUno"
          v-bind:class="{ 'was-validated': formularioValidado1 }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">1.- General Information</strong>
            <p class="parrafo-instrucciones mt-2">
              Enter your data correctly in each of the fields. Remember that you
              can use the help icon
              <i class="fas fa-question-circle icono-ayuda fa-lg"></i> to learn
              more details about how to fill it in.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Which service would you like to purchase?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a service * "
                :arreglo="this.catalogos.servicios"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosSolicitudGeneral.servicio"
                invalidFeedback="You must select a service."
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Which product would you like to purchase?"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a product *"
                :arreglo="this.catalogos.productos"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosSolicitudGeneral.producto"
                invalidFeedback="You must select a product."
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Given Name(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                maxlength="100"
                type="text"
                placeholder="Given Name(s) *"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.nombres"
                required
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Middle name"></etiqueta-campo>
              <input
                maxlength="100"
                placeholder="Middle name "
                type="text"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.apellidoMaterno"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Surname or family name"
                :requerido="true"
              ></etiqueta-campo>
              <input
                maxlength="100"
                type="text"
                placeholder="Surname or family name *"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.apellidoPaterno"
                required
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Passport number"></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                placeholder="Passport number "
                type="text"
                class="form-control campo-basico"
                required
                v-model="DatosPersonaFisica.numeroIdentificacion"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Passport number is required
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6" style="text-align: left">
              <etiqueta-campo
                texto="Date of birth"
                :requerido="true"
              ></etiqueta-campo>
              <input-fecha
                :deshabilitado="soloLectura"
                idioma="en-US"
                v-model="DatosSolicitudGeneral.fechaNacimiento"
                :fechaMaxima="new Date().toISOString()"
              ></input-fecha>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Date of birth is required
              </div>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Place of birth"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a place of birth *"
                :arreglo="this.catalogos.paises"
                llave="paisId"
                valor="paisId"
                texto="descripcionIngles"
                v-model="DatosPersonaFisica.lugarNacimiento"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Place of birth is required
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Nationality"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a nationality *"
                :arreglo="this.catalogos.paises"
                llave="paisId"
                valor="paisId"
                texto="gentilicioIngles"
                v-model="DatosPersonaFisica.nacionalidad"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Nationality is required
              </div>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Gender" :requerido="true"></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Gender *"
                :arreglo="this.catalogos.sexos"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.sexo"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Gender is required
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="ID type"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a ID type *"
                :arreglo="this.catalogos.tiposIdentificacion"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.tipoIdentificacion"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                ID type is required
              </div>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Marital estatus"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a marital estatus *"
                :arreglo="this.catalogos.estadosCiviles"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.estadoCivil"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div
            class="row row-cols-lg-12"
            hidden
            v-if="DatosPersonaFisica.estadoCivil != 1"
          >
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Financial marriage rules"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                placeholder="Select a financial marriage rules *"
                :arreglo="this.catalogos.regimenesMatrimoniales"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.regimenMatrimonial"
              ></DropDown>
            </div>
            <div class="col-lg-6"></div>
          </div>
          <div class="row row-cols-lg-12" v-else>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Financial marriage rules"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a financial marriage rules *"
                :arreglo="this.catalogos.regimenesMatrimoniales"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.regimenMatrimonial"
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6"></div>
          </div>
          <div
            v-if="DatosPersonaFisica.estadoCivil == 1"
            class="row row-cols-lg-12"
          >
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Spouse's full name"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  maxlength="100"
                  type="text"
                  placeholder="Spouse's full name *"
                  class="form-control campo-basico"
                  v-model="DatosPersonaFisica.nombreConyuge"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Spouse's home phone"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  placeholder="Spouse's home phone (10 digits)"
                  :disabled="this.soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                  min="0"
                  class="form-control campo-basico"
                  v-model="PuntoContactoConyuge.telefonoFijoConyuge.valor"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Spouse's cell phone"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="this.soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                  min="0"
                  placeholder="Spouse's cell phone (10 digits) *"
                  class="form-control campo-basico"
                  v-model="PuntoContactoConyuge.telefonoMovilConyuge.valor"
                  required
                />
              </div>
              <div class="col-lg-6 columna-campos">
                <etiqueta-campo
                  texto="Spouse's email address"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="this.soloLectura"
                  type="email"
                  placeholder="Spouse email (e.g. name@email.com) *"
                  class="form-control campo-basico campo-minuscula"
                  v-model="PuntoContactoConyuge.correoConyuge.valor"
                  required
                />
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <button
              ref="submitUno"
              @click.prevent="ValidaFormSiguiente"
              class="btn btn-primary"
              hidden
              type="submit"
            >
              Submit form
            </button>
          </div>
        </form>
      </div>
      <div ref="seccion-2" v-show="seccionActual == 2">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioDos"
          v-bind:class="{ 'was-validated': formularioValidado2 }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Address</strong>
            <p class="parrafo-instrucciones mt-2">
              Enter your current address information correctly.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Street" :requerido="true"></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                placeholder="Street *"
                type="text"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralParticular.calle"
                pattern="[A-Za-z0-9\s]{1,50}"
                required
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Number" :requerido="true"></etiqueta-campo>
              <input
                maxlength="20"
                :disabled="this.soloLectura"
                placeholder="Number *"
                type="text"
                min="0"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralParticular.numero"
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Zip Code"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Zip Code *"
                :disabled="this.soloLectura"
                type="text"
                min="0"
                class="form-control campo-basico"
                v-model="DatosUbicacionParticular.codigoPostal"
                required
                pattern="^[ A-Za-z0-9_@./#&+-]{1,10}$"
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Suburb/Town"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Suburb/Town *"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionParticular.ciudad"
                pattern="[A-Za-z\s]{4,}"
                type="text"
                class="form-control campo-basico"
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="State" :requerido="true"></etiqueta-campo>
              <input
                placeholder="State *"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionParticular.estado"
                type="text"
                class="form-control campo-basico"
                pattern="[A-Za-z\s]{4,}"
                required
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Country"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Country *"
                :arreglo="this.catalogos.paises"
                llave="paisId"
                valor="paisId"
                texto="descripcionIngles"
                v-model="DatosUbicacionParticular.paisId"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Phone"></etiqueta-campo>
              <input
                placeholder="PHONE (10 DIGITS)"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                min="0"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoFijo.valor"
              />
            </div>
            <div
              class="col-lg-6"
              v-if="PuntoContactoGeneral.telefonoMovil.valor != null"
            >
              <etiqueta-campo
                texto="Mobile phone"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                min="0"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
              />
            </div>
            <div class="col-lg-6" v-else>
              <etiqueta-campo
                texto="Mobile phone"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                min="0"
                placeholder="Mobile phone (10 digits) *"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoMovil.valor"
                required
              />
            </div>
          </div>
          <div class="row row-cols-lg-12" style="align-items: center">
            <div
              class="col-lg-5"
              v-if="PuntoContactoGeneral.correo1.valor != null"
            >
              <etiqueta-campo texto="E-mail" :requerido="true"></etiqueta-campo>
              <input
                disabled
                type="email"
                placeholder="Ej. name@mail.com"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correo1.valor"
                required
              />
            </div>
            <div class="col-lg-5" v-else>
              <etiqueta-campo texto="E-mail" :requerido="true"></etiqueta-campo>
              <input
                type="email"
                placeholder="Ej. name@mail.com"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correo1.valor"
                required
              />
            </div>
            <div class="col-lg-1 col-sm-1">
              <span
                v-tooltip.right="
                  'In case your phone number or email are incorrect, please contact your ambassador.'
                "
              >
                <i
                  class="fas fa-question-circle icono-ayuda fa-lg"
                  style="margin-right: 10px; margin-top: 4px"
                ></i>
              </span>
            </div>
          </div>
          <button
            ref="submitDos"
            @click.prevent="ValidaFormSiguiente"
            hidden
            type="submit"
          >
            Submit form
          </button>
        </form>
      </div>
      <div ref="seccion-3" v-show="seccionActual == 3">
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioTres"
          v-bind:class="{ 'was-validated': formularioValidado3 }"
        >
          <div class="row row-cols-lg-12 w-100 mt-3">
            <strong class="titulo-seccion">Income Profile</strong>
            <p class="parrafo-instrucciones mt-2">
              Enter your income data correctly.
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Occupation"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a occupation*"
                :arreglo="this.catalogos.profesiones"
                llave="profesionId"
                valor="profesionId"
                texto="descripcionIngles"
                v-model="DatosPersonaFisica.profesion"
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Academic degree"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                placeholder="Select a academic degree*"
                :arreglo="this.catalogos.gradosEstudio"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.gradoEstudios"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Number of dependents"></etiqueta-campo>
              <input
                placeholder="Number of dependents"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                min="0"
                max="10"
                maxlength="2"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.numeroDependientes"
              />
            </div>
            <div class="col-lg-6 campo-solicitud">
              <etiqueta-campo
                texto="Currency of your income/expenditure"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                invalidFeedback="The currency is required."
                placeholder="Select the currency of your income/expenditure. *"
                :arreglo="this.catalogos.divisas"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosIngreso.divisa"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Monthly income"
                :requerido="true"
              ></etiqueta-campo>
              <VueAutonumeric
                :disabled="this.soloLectura"
                class="form-control campo-basico"
                :options="opcionesAutoNumeric"
                :placeholder="'Monthly Income *'"
                v-model="DatosIngreso.monto"
                required
              ></VueAutonumeric>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Monthly expenditure"
                :requerido="true"
              ></etiqueta-campo>
              <VueAutonumeric
                :disabled="this.soloLectura"
                class="form-control campo-basico"
                :options="opcionesAutoNumeric"
                :placeholder="'Monthly expenditure *'"
                v-model="DatosPersonaFisica.egresoMensual"
                required
              ></VueAutonumeric>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Type of housing"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a type of housing*"
                :arreglo="this.catalogos.tiposVivienda"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.tipoVivienda"
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Comercial activity"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                placeholder="Select a comercial activity*"
                :arreglo="this.catalogos.tiposEmpleo"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosPersonaFisica.tipoEmpleo"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Type of income"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                :requerido="true"
                placeholder="Select a type of income*"
                :arreglo="this.catalogos.tiposIngreso"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosIngreso.tipoIngreso"
              ></DropDown>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Company name"></etiqueta-campo>
              <input
                placeholder="Company name"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosIngreso.empresa"
              />
            </div>
          </div>

          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Current position"></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Current position *"
                invalidFeedback="You must choose a position"
                :arreglo="this.catalogos.puestos"
                llave="puestoId"
                valor="puestoId"
                texto="puestoIngles"
                v-model="DatosIngreso.puestoId"
              ></DropDown>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Seniority (years)"></etiqueta-campo>
              <input
                placeholder="Seniority (years)"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                min="0"
                max="65"
                maxlength="2"
                class="form-control campo-basico"
                v-model="DatosIngreso.antiguedadAnios"
              />
            </div>
          </div>

          <!-- <div class="row row-cols-lg-12">
            <div
              class="col-lg-6 columna--campos"
              hidden
              v-if="DatosIngreso.puestoId != 19"
            >
              <etiqueta-campo
                texto="Current position"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Current position"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosIngreso.otroPuesto"
              />
            </div>
            <div class="col-lg-6 columna--campos" v-else>
              <etiqueta-campo
                texto="Current position"
                :requerido="true"
              ></etiqueta-campo>
              <input
                placeholder="Current position"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosIngreso.otroPuesto"
              />
            </div>
          </div> -->

          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Department"></etiqueta-campo>
              <input
                placeholder="Department"
                :disabled="this.soloLectura"
                type="texto"
                class="form-control campo-basico"
                v-model="DatosPersonaFisica.departamentoEmpleo"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Company line of business"></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Company's line of business"
                :arreglo="this.catalogos.giros"
                llave="giroId"
                valor="giroId"
                texto="giroIngles"
                v-model="DatosIngreso.giroEmpresaId"
              ></DropDown>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Company address (Street)"></etiqueta-campo>
              <input
                placeholder="Company address (Street)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralOficina.calle"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Company address (Number)"></etiqueta-campo>
              <input
                maxlength="20"
                placeholder="Company address (Number)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralOficina.numero"
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Zip Code"></etiqueta-campo>
              <input
                placeholder="Zip Code"
                :disabled="this.soloLectura"
                type="text"
                min="0"
                class="form-control campo-basico"
                v-model="DatosUbicacionOficina.codigoPostal"
                pattern="^[ A-Za-z0-9_@./#&+-]{1,10}$"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Company address (Suburb/Town)"
              ></etiqueta-campo>
              <input
                placeholder="Suburb/Town"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionOficina.ciudad"
                type="text"
                class="form-control campo-basico"
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Company address (State)"></etiqueta-campo>
              <input
                placeholder="State"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionOficina.estado"
                type="text"
                class="form-control campo-basico"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Company address (Country)"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a country"
                :arreglo="this.catalogos.paises"
                llave="paisId"
                valor="paisId"
                texto="descripcionIngles"
                v-model="DatosUbicacionOficina.paisId"
              ></DropDown>
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Phone"></etiqueta-campo>
              <input
                placeholder="Phone (10 Digits)"
                :disabled="this.soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                min="0"
                class="form-control campo-basico"
                v-model="PuntoContactoGeneral.telefonoFijoOficina.valor"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Office E-mail"></etiqueta-campo>
              <input
                :disabled="this.soloLectura"
                type="email"
                placeholder="e.g., person@company.com"
                class="form-control campo-basico campo-minuscula"
                v-model="PuntoContactoGeneral.correo2.valor"
              />
            </div>
          </div>
          <button
            ref="submitTres"
            @click.prevent="ValidaFormSiguiente"
            hidden
            type="submit"
          >
            Submit form
          </button>
        </form>
      </div>
      <div ref="seccion-4" v-show="seccionActual == 4">
        <div class="row row-cols-lg-12 w-100 mt-3">
          <strong class="titulo-seccion">Beneficiaries</strong>
          <p class="parrafo-instrucciones mt-2">
            Enter your beneficiaries data correctly
          </p>
        </div>
        <div
          v-for="(formBeneficiario, index) in FormBeneficiarios"
          v-bind:key="index"
        >
          <form class="mt-3" novalidate>
            <div class="row row-cols-lg-12">
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Given name(s)"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Given Name(s) *"
                  class="form-control campo-basico"
                  v-model="formBeneficiario.nombre"
                  required
                />
              </div>
              <div class="col-lg-6">
                <etiqueta-campo texto="Middle name"></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Middle name"
                  v-model="formBeneficiario.apellidoMaterno"
                  class="form-control campo-basico"
                />
              </div>
            </div>
            <div class="row row-cols-lg-12" style="margin-top: -10px">
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Surname or family name"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Surname or family name *"
                  v-model="formBeneficiario.apellidoPaterno"
                  class="form-control campo-basico"
                  required
                />
              </div>
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Type of relationship"
                  :requerido="true"
                ></etiqueta-campo>
                <DropDown
                  :disabled="soloLectura"
                  placeholder="Type of relationship*"
                  :arreglo="catalogos.parentescos"
                  llave="value"
                  valor="value"
                  texto="text"
                  v-model="formBeneficiario.parentesco"
                  :requerido="true"
                ></DropDown>
              </div>
            </div>
            <div class="row row-cols-lg-12" style="margin-top: -10px">
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Percentage"
                  :requerido="true"
                ></etiqueta-campo>
                <div class="input-group">
                  <input
                    :disabled="soloLectura"
                    @keyup="LimitarPorcentaje(index)"
                    type="number"
                    onkeydown="return event.keyCode !== 69"
                    min="0"
                    class="form-control campo-basico"
                    v-model="formBeneficiario.porcentaje"
                    placeholder="e.g., 70"
                    required
                  />
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="border-radius: 0px; border: 1px solid"
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Mobile phone"
                  :requerido="true"
                ></etiqueta-campo>
                <input
                  :disabled="soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                  min="0"
                  placeholder="Mobile phone (10 Digits) *"
                  v-model="formBeneficiario.telefono"
                  class="form-control campo-basico"
                  required
                />
              </div>
            </div>
            <div
              class="col-lg-12 col-sm-12"
              style="text-align: end"
              v-if="soloLectura == false"
            >
              <strong
                v-if="FormBeneficiarios.length > 1"
                class="etiqueta-nuevo-documento"
                @click.prevent="EliminarBeneficiarioTest(index)"
                >Delete beneficiarie</strong
              >
            </div>
          </form>
        </div>
        <div class="col-lg-12 col-sm-12" style="text-align: end">
          <label
            v-if="this.soloLectura == false"
            class="etiqueta-nuevo-documento"
            @click.prevent="AgregarFormBeneficiario(true)"
            >Add another beneficiarie</label
          >
        </div>
      </div>
      <div ref="seccion-5" v-show="seccionActual == 5">
        <div class="row row-cols-lg-12 w-100 mt-3">
          <strong class="titulo-seccion">Personal references (Optional)</strong>
          <p class="parrafo-instrucciones mt-2">
            Enter correctly the data of your personal reference(s).
          </p>
        </div>
        <div
          v-for="(formReferencia, index) in FormReferencias"
          v-bind:key="index"
          class="mb-3"
        >
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Given name(s)"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="text"
                placeholder="Given Name(s) *"
                class="form-control campo-basico campo-item-anadido"
                v-model="formReferencia.nombre"
                required
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="Middle name"></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="text"
                placeholder="Middle name"
                v-model="formReferencia.apellidoMaterno"
                class="form-control campo-basico campo-item-anadido"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Surname or family name*"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="text"
                placeholder="Surname or family name"
                v-model="formReferencia.apellidoPaterno"
                class="form-control campo-basico campo-item-anadido"
                required
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Type of relationship"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="soloLectura"
                placeholder="Select a relationship *"
                :arreglo="catalogos.parentescos"
                llave="value"
                valor="value"
                texto="text"
                v-model="formReferencia.relacion"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Years of knowing each other"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                placeholder="Years of knowing each other *"
                class="form-control campo-basico campo-item-anadido"
                max="80"
                v-model="formReferencia.aniosRelacion"
                required
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo texto="E-mail"></etiqueta-campo>
              <input
                @change="ValidarCorreoReferencia(index)"
                :disabled="soloLectura"
                type="email"
                placeholder="e.g, josephsmith@email.com"
                class="
                  form-control
                  campo-basico campo-item-anadido campo-minuscula
                "
                v-model="formReferencia.correo"
              />
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <etiqueta-campo texto="Phone"></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                placeholder="Phone (10 Digits)"
                class="form-control campo-basico campo-item-anadido"
                max="80"
                v-model="formReferencia.telefonoParticular"
              />
            </div>
            <div class="col-lg-6">
              <etiqueta-campo
                texto="Mobile phone"
                :requerido="true"
              ></etiqueta-campo>
              <input
                :disabled="soloLectura"
                type="number"
                onkeydown="return event.keyCode !== 69"
                placeholder="Mobile phone (10 Digits)*"
                class="form-control campo-basico campo-item-anadido"
                v-model="formReferencia.telefonoMovil"
                required
              />
            </div>
          </div>
          <div
            class="col-lg-12 col-sm-12"
            style="text-align: end"
            v-if="soloLectura == false"
          >
            <strong
              v-if="
                FormReferencias.length > 0 && index >= 0
              "
              class="etiqueta-nuevo-documento"
              @click.prevent="EliminarReferenciaTest(index)"
              >Delete reference</strong
            >
          </div>

          <!--<div class="col-lg-12 col-sm-12" style="text-align: end">
          <label
            v-if="this.soloLectura == false"
            class="etiqueta-nuevo-documento"
            @click.prevent="LimpiarFormReferencia(index)"
            >Clean fields</label
          >
        </div>-->
        </div>

        <div class="col-lg-12 col-sm-12" style="text-align: end">
          <label
            v-if="this.soloLectura == false && FormReferencias.length < 2"
            class="etiqueta-nuevo-documento"
            @click.prevent="AgregarFormReferencia(true)"
            >Add another personal reference</label
          >
        </div>
        <form
          class="requiere-validacion"
          novalidate
          ref="formularioUltimo"
          v-bind:class="{ 'was-validated': formularioUltimoValidado }"
        >
          <div class="row row-cols-lg-12 w-100 mt-4">
            <p class="parrafo-instrucciones mt-2">
              In case your application to the financing is approved, how will
              you cover the inscription fee:
            </p>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6" style="text-align: left">
              <etiqueta-campo
                texto="Payment option"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a payment option *"
                :arreglo="this.catalogos.mediosPago"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosSolicitudGeneral.enCasoAutorizacion"
                :requerido="true"
              ></DropDown>
            </div>
            <div class="col-lg-6" style="text-align: left">
              <etiqueta-campo
                texto="Means to receive the account statement"
                :requerido="true"
              ></etiqueta-campo>
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a way to receive your statement *"
                :arreglo="this.catalogos.tiposEnvio"
                llave="value"
                valor="value"
                texto="text"
                v-model="DatosSolicitudGeneral.envioEstadoCuenta"
                :requerido="true"
              ></DropDown>
            </div>
          </div>
          <div class="row row-cols-lg-12" style="text-align: justify">
            <div class="pl-2">
              <div class="form-check mt-4">
                <input
                  :disabled="this.soloLectura"
                  class="form-check-input"
                  style="font-size: 14px"
                  type="checkbox"
                  v-model="DatosSolicitudGeneral.aceptaInformacionTerceros"
                />
                <label
                  class="form-check-label font-weight-bold terminos-solicitud"
                  >I accept that HIR Casa assigns or transmits information to
                  third parties, for marketing or advertising purposes, the
                  information provided for the purpose of this adhesion
                  contract.</label
                >
              </div>
              <div class="form-check mt-4">
                <input
                  :disabled="this.soloLectura"
                  class="form-check-input"
                  style="font-size: 14px"
                  type="checkbox"
                  v-model="DatosSolicitudGeneral.aceptaInformacionPublicitaria"
                />
                <label
                  class="form-check-label font-weight-bold terminos-solicitud"
                  >I accept that HIR Casa sends me advertising about goods and
                  services.</label
                >
              </div>
            </div>
          </div>
          <div class="col-12">
            <button
              ref="submitUltimo"
              @click.prevent="GuardarSolicitudCompletamente"
              class="btn btn-primary"
              hidden
              type="submit"
            ></button>
          </div>
        </form>
      </div>
      <div
        class="row row-cols-lg-12 mt-2 mb-2"
        style="justify-content: flex-end"
      >
        <button
          type="button"
          class="boton-transparente boton-seccion-anterior"
          @click.prevent="AnteriorSeccion()"
          v-if="seccionActual != 1"
        >
          Previous
        </button>
        <button
          type="button"
          class="boton-primario boton-siguiente-seccion"
          @click.prevent="SeccionSiguiente()"
          v-if="seccionActual != 5"
        >
          Next
        </button>
        <div
          style="display: contents"
          v-if="
            (solicitudExistenteId == 0 || solicitudExistenteId == null) &&
              seccionActual == 5
          "
        >
          <button
            v-if="tipoUsuario == 0 || tipoUsuario == 2 || tipoUsuario == 5"
            disabled
            class="boton-primario boton-siguiente-seccion"
            style="opacity: 0.5; cursor: default"
          >
            Finish
          </button>
          <button
            v-else
            type="button"
            :disabled="this.soloLectura"
            class="boton-primario boton-siguiente-seccion"
            @click.prevent="ActivarEnvioFormularioExtranjero"
          >
            Finish
          </button>
        </div>
        <div
          style="display: contents"
          v-else-if="
            (solicitudExistenteId != 0 || solicitudExistenteId != null) &&
              seccionActual == 5
          "
        >
          <button
            v-if="tipoUsuario == 0 || tipoUsuario == 2 || tipoUsuario == 5"
            disabled
            class="boton-primario boton-siguiente-seccion"
            style="opacity: 0.5; cursor: default"
          >
            Update
          </button>
          <button
            v-else
            type="button"
            class="boton-primario boton-siguiente-seccion"
            @click.prevent="ActivarEnvioFormularioExtranjero"
          >
            <span v-if="!confirmandoDatos">Update</span>
            <v-progress-circular
              v-else
              indeterminate
              size="30"
              color="primary"
            ></v-progress-circular>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

//Componentes
import DropDown from "../components/DropDown.vue";
import Stepper from "../components/Stepper.vue";
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
import StepperMovil from "../components/StepperMovil.vue";
import InputFecha from "../components/InputFecha.vue";
//Plugins
import axios from "axios";
import servicios from '../../../servicios/service.js';
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
//Rutas API
const rutaGuardarSolicitud = "/api/Master/SolicitudInscripcion/GuardarSolicitudInscripcion";
const rutaGuardarSolicitudPf = "/api/Master/SolicitudInscripcion/GuardarSolicitudInscripcionPf";
//const rutaGuardarUbicacion = "/api/Master/SolicitudInscripcion/GuardarUbicacionGeneral";
//const rutaGuardarUbicacionExtranjera = "/api/Master/SolicitudInscripcion/GuardarUbicacionExtranjera";

const prospecto = {
  params:{
    prospectoId: null
  }
}

export default {
  name:"FormularioSolicitudInscripcion",
  components: {
    DropDown,
    VueAutonumeric,
    Stepper,
    StepperMovil,
    InputFecha
  },
  mixins: [mixinSolicitudInscripcion],
  data() {
    return {
      pasos: ['General information', 'Address', 'Income','Beneficiaries', 'Personal references' ],
       FormReferencias: [
          {
            referenciaPersonalId:0,
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            relacion: null,
            correo:"",
            aniosRelacion: null,
            telefonoParticular: null,
            telefonoMovil : null
          }
        ],
      FormBeneficiarios: [
          {
            beneficiarioId: 0,
            nombre: null,
            apellidoPaterno: null,
            apellidoMaterno: null,
            parentesco: null,
            porcentaje: null,
            telefono: null
          }
        ],
      seccionActual:1,
      NombreCompletoProspecto: "",
      tipoUsuario: null,
      formularioBeneficiariosValidado: false,
      formularioReferenciasValidado: false,
      formularioUltimoValidado: false,
      formularioValidado1: false,
      formularioValidado2: false,
      formularioValidado3: false,
      formularioValidado4: false,
      formularioValidado5: false,
      //Propiedades del autonumeric
      opcionesAutoNumeric: {
        digitGroupSeparator: ',',
        decimalCharacter: '.',
        decimalCharacterAlternative: '.',
        currencySymbol: '$',
        currencySymbolPlacement: 'p',
        roundingMethod: 'U',
        minimumValue: '0',
        maximumValue: '15000000'
      },
      solicitudExistenteId: null,
        ProspectoId: null,
        catalogos: {
            productos: [],
            servicios: [],
            paises:[],
            sexos:[],
            tiposIdentificacion: [],
            estadosCiviles: [],
            regimenesMatrimoniales: [],
            colonias: [],
            coloniasEmpresa:[],
            profesiones: [],
            tiposVivienda: [],
            gradosEstudio: [],
            tiposEmpleo: [],
            tiposIngreso: [],
            tiposEnvio:[],
            parentescos: [],
            mediosPago: [],
            giros: [],
            regimenesFiscales: [],
            puestos: []
        },
        DatosSolicitudGeneral: {
            prospectoId:null,
            producto: null,
            servicio: null,
            fechaRegistroSolicitud:null,
            fechaNacimiento: null,
            envioEstadoCuenta:null,
            envioEstadoCuentaOriginal:null,
            enCasoAutorizacion : null,
            requiereFactura:false,
            aceptaInformacionTerceros: false,
            aceptaInformacionPublicitaria: false,
            seccionActual: null,
            solicitudCompletada: false
        },
        DatosPersonaFisica: {
          solicitudId: null,
          nombreConyuge: "",
          nombres: null,
          apellidoPaterno: null,
          apellidoMaterno: "",
          rfc: null,
          numeroIdentificacion: null,
          nacionalidad: null,
          sexo: null,
          lugarNacimiento: null,
          curp: null,
          tipoIdentificacion: null,
          estadoCivil: null,
          regimenMatrimonial: null,
          gradoEstudios:null,
          profesion: null,
          regimenFiscal: null,
          numeroDependientes: null,
          egresoMensual: null,
          tipoVivienda: null,
          tipoEmpleo: null,
          departamentoEmpleo: null,
          regimenFiscalId: null,
      },
        DatosReferencia: {
          nombre: "",
          apellidoPaterno: "",
          apellidoMaterno: "",
          relacion: null,
          correo:"",
          aniosRelacion: null,
          telefonoParticular: null,
          telefonoMovil : null
        },
        DatosUbicacionGeneralParticular: {
            ubicacionId : 0,
            prospectoId: null,
            tipoUbicacion:0,
            calle: null,
            numero: null
        },
        DatosUbicacionGeneralOficina: {
            ubicacionId : 0,
            prospectoId: null,
            tipoUbicacion:1,
            calle: null,
            numero: null
        },
        DatosUbicacionParticular: {
          ubicacionId:null,
          paisId:null,
          estado:null,
          ciudad:null,
          codigoPostal: null
        },
        DatosUbicacionOficina: {
          ubicacionId:null,
          paisId:null,
          estado:null,
          ciudad:null,
          codigoPostal: null
        },
        PuntosContacto: [],

        PuntoContactoConyuge: {
          telefonoFijoConyuge: {
            puntoContactoId: 0,
            valor: null,
          },
          telefonoMovilConyuge: {
            puntoContactoId: 0,
            valor: null,
          },
          correoConyuge: {
            puntoContactoId: 0,
            valor: null,
          },
        },
        PuntoContactoGeneral:{
          telefonoFijo: {
            puntoContactoId: 0,
            valor: null
          },
          telefonoMovil:{
            puntoContactoId: 0,
            valor: null
          },
          correo1: {
            puntoContactoId: 0,
            valor: ""
          },
          correo2: {
            puntoContactoId: 0,
            valor: ""
          },
          telefonoFijoOficina: {
            puntoContactoId: 0,
            valor: ""
          },
        },
         DatosIngreso: {
          ingresoId: 0,
          prospectoId: null,
          tipoIngreso: null,
          divisa:null,
          empresa: "",
          giroEmpresa: null,
          puesto:"",
          otroPuesto:"",
          giroEmpresaId: null,
          puestoId: null,
          monto: null,
          antiguedadMeses:null,
          antiguedadAnios: null,
          utilidad:null,
          esPersonaMoral: false
        },
        referencias:[],
        soloLectura: false,
        edadProspecto:null,
        esMayorDeEdad: false,
        confirmandoDatos: false
    }
  },
   async mounted (){
     //Se cargan todos los datos para los dropdown's
     await this.CargarProductos(true);
     await this.CargarServicios(true);
     await this.CargarPaises(true);
     await this.CargarSexos(true);
     await this.CargarTiposIdentificacion(true);
     await this.CargarEstadosCiviles(true);
     await this.CargarRegimenesMatrimoniales(true);
     await this.CargarDivisas(true);
     await this.CargarMediosPago(true);
     await this.CargarProfesiones(true);
     await this.CargarTiposVivienda(true);
     await this.CargarGradosEstudio(true);
     await this.CargarTiposEmpleo(true);
     await this.CargarTiposEnvioEC(true);
     await this.CargarTiposIngreso(true);
     await this.CargarParentescos(true);
    await this.CargarPuestos(true);
    await this.CargarGiros(true);
    await this.CargarRegimenesFiscales(true, false);
    //Se obtiene el prospecto
    this.ProspectoId = this.$store.getters.prospectoId;
    prospecto.params.prospectoId = this.ProspectoId;
    this.solicitudExistenteId = this.$store.getters.solicitudExtranjeraId;
    await this.CargarDatosProspecto(this.ProspectoId);
    this.DatosSolicitudGeneral.prospectoId = parseInt(this.ProspectoId);
    this.DatosUbicacionGeneralParticular.prospectoId = parseInt(this.ProspectoId);
    this.DatosUbicacionGeneralOficina.prospectoId = parseInt(this.ProspectoId);
    this.DatosIngreso.prospectoId = parseInt(this.ProspectoId);
    let datos = (await this.ObtenerDatosProspecto(this.ProspectoId)).data.data;
    this.NombreCompletoProspecto = "INSCRIPTION REQUEST: " + datos.nombres + " " + datos.apellidoMaterno + " " + datos.apellidoPaterno;

    //Se obtienen los datos de la solicitud
    if(this.solicitudExistenteId != 0) {
      await this.ConsultarSolicitudGeneral();
      await this.ConsultarSolicitudPersonaFisica();
      await this.ConsultarUbicacionesExtranjeras(this.ProspectoId);
      await this.ConsultarPerfilIngreso();
      await this.ConsultarBeneficiariosTest();
      await this.ConsultarReferenciasTest();
    }
    this.tipoUsuario = this.$store.getters.tipoUsuario;

     this.VerificarSoloLectura();


    if(this.etapaProspecto > 4) this.soloLectura = true;
    if(this.etapaProspecto > 4)
    {
     this.seccionActual = 1;
    }

  if (this.tipoUsuario != 3) {
              this.seccionActual = 1;
            }

  },
  computed: {
    camposVaciosBeneficiarioForm: function() {
      const formulario = this.FormBeneficiarios[this.FormBeneficiarios.length - 1];
      const clavesIgnoradas = ["apellidoMaterno", "beneficiarioId", "solicitudId"];
      const estaVacioONulo = (valor) => valor === "" || valor === null;
      const esConyuge = (valor) => valor === 0;
      let vacios = 0;

      for (const clave in formulario) {
        if (!clavesIgnoradas.includes(clave)) {
          const valor = formulario[clave];
          if (clave === "parentesco") {
            if (!esConyuge(valor) && estaVacioONulo(valor)) {
              vacios++;
            }
          } else {
            if (estaVacioONulo(valor) || valor < -1) {
              vacios++;
            }
          }
        }
      }
      return vacios > 0;
    },
    camposVaciosReferenciaForm: function() {
      const formulario = this.FormReferencias[this.FormReferencias.length - 1];
      const clavesIgnoradas = ["apellidoMaterno", "referenciaPersonalId", "correo", "telefonoParticular"];
      const estaVacioONulo = (valor) => valor === "" || valor === null;
      const esConyuge = (valor) => valor === 0;
      let vacios = 0;

      for (const clave in formulario) {
        if (!clavesIgnoradas.includes(clave)) {
          const valor = formulario[clave];

          if (clave === "relacion") {
            if (!esConyuge(valor) && (estaVacioONulo(valor) || valor < 0)) {
              vacios++;
            }
          } else {
            if (estaVacioONulo(valor) || valor < 0) {
              vacios++;
            }
          }
        }
      }
      return vacios > 0;
    },
  },
  methods: {
    //ALERTA PERSONALIZADA
    AlertaEmbajadores(mensaje, bold, esExtranjero) {
      console.log(esExtranjero);
      if(bold){
        this.$fire({
          title: mensaje,
          confirmButtonText: "Accept",
          cancelButtonText: "Cancel",
          showCancelButton: false
        });
      } else{
        this.$fire({
          text: mensaje,
          confirmButtonText: "Accept",
          cancelButtonText: "Cancel",
          showCancelButton: false
        });
      }
    },
    OrdenarPaises(arregloPaises){
      let paisesPrincipales = [];
      arregloPaises.forEach(p => {
        if(p.descripcionIngles === 'USA' || p.descripcionIngles === 'CANADA'){
          paisesPrincipales.push(p);
          arregloPaises.splice(arregloPaises.indexOf(p),1);
        }
      });
      arregloPaises.unshift(paisesPrincipales[0]);
      arregloPaises.unshift(paisesPrincipales[1]);
      return arregloPaises;
    },
    LimitarPorcentaje(index){
      this.FormBeneficiarios[index].porcentaje = this.FormBeneficiarios[index].porcentaje != null ? parseFloat(this.FormBeneficiarios[index].porcentaje) : 0;
      if(this.FormBeneficiarios.length == 1){
          if(this.FormBeneficiarios[0].porcentaje > 100) {
            this.FormBeneficiarios[0].porcentaje = 100;
          }
        } else {
            if(this.SumaPorcentajes() > 100){
              let resta = this.SumaPorcentajes() - this.FormBeneficiarios[index].porcentaje;
              let faltante = 100 - resta;
              this.FormBeneficiarios[index].porcentaje = faltante;
            }
        }
    },
    GuardarBorradorSolicitud() {
      if(this.seccionActual == 1) {
        let camposLlenos = 0;
        var llaves = Object.keys(this.DatosSolicitudGeneral);
        llaves.forEach((llave) => {
          if(typeof this.DatosSolicitudGeneral[llave] != "boolean")
            if((llave != "solicitudId" && llave != "prospectoId"  && llave != "seccionActual") && this.DatosSolicitudGeneral[llave] != null)
              camposLlenos ++;
        });
        if(camposLlenos >= 1) {
          this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
          this.AjustarTiposDeDatos();
          this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
        } else {
          this.AlertaEmbajadores("To save your progress you must fill in at least one field.", true, true);
        }
      } else {
        this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
        this.AjustarTiposDeDatos();
        this.GuardarSolicitud(this.DatosSolicitudGeneral,true);
      }
    },
    GuardarSolicitudCompletamente(){
      let formularioValidado = false;
      this.formularioUltimoValidado = true;
      formularioValidado = this.$refs.formularioUltimo.checkValidity();

      if(formularioValidado) {
        //Se guarda toda la solicitud
        this.DatosSolicitudGeneral.seccionActual = this.seccionActual;
        this.DatosSolicitudGeneral.solicitudCompletada = true;
        this.AjustarTiposDeDatos();
        this.GuardarSolicitud(this.DatosSolicitudGeneral, false);
      }
    },
    SeccionSiguiente(){
      switch (this.seccionActual) {
        case 1:
          this.$refs.submitUno.click();
          break;
        case 2:
          this.$refs.submitDos.click();
          break;
        case 3:
          this.$refs.submitTres.click();
          break;
        case 4:
          if(this.FormBeneficiarios.length > 0) {
            let camposVacios = 0;
            for (var beneficiario of this.FormBeneficiarios) {
              if(this.CamposActualesVacios(this.FormBeneficiarios.indexOf(beneficiario))){
                camposVacios++;
              }
            }
            if(camposVacios > 0){
              this.AlertaEmbajadores("You have not filled in all required fields in some of your beneficiaries.", true, true)
              return;
            } else {
              for(var b of this.FormBeneficiarios){
                if (b.telefono == null || b.telefono.length != 10) {
                  this.AlertaEmbajadores("The telephone number of the beneficiaries must have 10 digits.", true, true);
                  return;
                }
              }
              if(this.SumaPorcentajes() == 100) {
                this.seccionActual++;
              } else{
                this.AlertaEmbajadores("Beneficiaries must complete 100%.", true, true);
                return;
              }
            }
          } else {
            this.AlertaEmbajadores("You must enter at least one beneficiary.", true, true);
            return;
          }
          break;
      }
    },
    AnteriorSeccion(){
      if(this.seccionActual != 1) {
        this.seccionActual--;
      }
    },
    ValidaFormSiguiente(){
      let formularioValidado = false;
      switch (this.seccionActual) {
        case 1:
          this.formularioValidado1 = true;
          formularioValidado = this.$refs.formularioUno.checkValidity();
          break;
        case 2:
          this.formularioValidado2 = true;
          formularioValidado = this.$refs.formularioDos.checkValidity();
          break;
        case 3:
          this.formularioValidado3 = true;
          formularioValidado = this.$refs.formularioTres.checkValidity();
          break;
      }

      if(formularioValidado) {
        if(this.seccionActual == 1) {
          if(this.DatosSolicitudGeneral.fechaNacimiento != null) {
            if(!this.esMayorDeEdad){
              this.AlertaEmbajadores("You must be legal age (18+) to continue the process.", true, true);
              return;
            } else {
              this.seccionActual++;
            }
          } else {
            this.AlertaEmbajadores("Please indicate your date of birth.", true, true);
            return;
          }
        } else if(this.seccionActual != 5){
          this.seccionActual++;
        }
      }

    },
    ValidarCorreoReferencia(index){
      const regexCorreo = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(this.FormReferencias.length == 1){
          if(!regexCorreo.test(this.FormReferencias[0].correo.toLowerCase())) {
            this.AlertaEmbajadores("The e-mail does not have a valid format", true, true);
            this.FormReferencias[0].correo = "";
          }
        } else {
              if(!regexCorreo.test(this.FormReferencias[index].correo.toLowerCase())) {
                this.AlertaEmbajadores("The e-mail does not have a valid format", true, true);
                this.FormReferencias[index].correo = "";
              }
        }
    },
    ObtenerStringRelacionIngles(relacion) {
      return servicios.ObtenerStringRelacionIngles(relacion);
    },
    //GUARDADO DE DATOS
    ActivarEnvioFormularioExtranjero() {
      this.$refs.submitUltimo.click();
    },
    //validaciones
    async GuardarSolicitud(solicitudGeneral, esBorrador){
      this.confirmandoDatos = true
      const solicitudPersonaFisica = this.DatosPersonaFisica;
      axios.post(rutaGuardarSolicitud, solicitudGeneral)
        .then(async response => {
          if (response.data.estado === 0) {
            let solicitudId = response.data.data;
            this.DatosPersonaFisica.solicitudId = solicitudId;

            if(this.FormReferencias.length > 0){
            if(this.ValidarRerencias(true) != 'validas'){
              this.AlertaEmbajadores(this.ValidarRerencias(true), true, true);
              this.confirmandoDatos = false
              return;
            } else {
              this.GuardarReferenciasTest(solicitudId);
            }
            }

            this.GuardarSolicitudPF(solicitudPersonaFisica);
            this.GuardarUbicacionGeneralParticular(true);
            this.GuardarUbicacionGeneralOficina(true);
            if(this.ValidarMinimoCamposIngreso()) {
              this.catalogos.giros.forEach(x => {
                if(x.giroId == this.DatosIngreso.giroEmpresaId) this.DatosIngreso.giroEmpresa = x.giroIngles;
              });
              await this.GuardarIngresos(this.DatosIngreso);
            }else{
              this.confirmandoDatos = false
            }
            this.solicitudExistenteId != 0 ? this.GuardarPuntosDeContacto(true, false) : this.GuardarPuntosDeContacto(true,true);

            if(this.DatosPersonaFisica.estadoCivil == 1)
            {
              this.solicitudExistenteId != 0 ? this.GuardarPuntosDeContactoConyuge(true, false) : this.GuardarPuntosDeContactoConyuge(true,true);
            }

            if(this.FormBeneficiarios.length > 0){
              this.GuardarBeneficiariosTest(solicitudId);
            }else{
              this.confirmandoDatos = false
            }

            esBorrador ? this.AlertaEmbajadores("Progress successfully saved", true, true) : this.AlertaEmbajadores("Inscription request successfully saved.", true, true);

            if(this.$route.params.vieneDeAdministracion != undefined){
              this.$router.push({name: "IntegracionExpedienteExtranjero", params: { prospectoId: this.ProspectoId, vieneDeAdministracion: true }});
            } else {
              if(this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {
                if(this.etapaProspecto == 4){
                  this.$router.push({name: "IntegracionExpedienteExtranjero"});
                } else {
                  this.$router.push({name: "PreAutorizacion"});
                }
              } else {
                if(this.tipoUsuario == 4) {
                  this.$router.push({name: "PreAutorizacion"});
                } else {
                  this.$router.push({name: "IntegracionExpedienteExtranjero"});
                }
              }
            }


          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
          this.confirmandoDatos = false
        });
    },
     GuardarSolicitudPF(solicitudPf){
      axios.post(rutaGuardarSolicitudPf, solicitudPf)
        .then(() => {})
        .catch(e => {
             this.ManejarExcepcion(e);
        });
    },
    ValidarMinimoCamposIngreso() {
      let camposLlenos = 0;
      Object.keys(this.DatosIngreso).forEach(llave => {
        if(llave != "ingresoId" && llave != "prospectoId")
          if(this.DatosIngreso[llave] != null && this.DatosIngreso[llave] != "" && this.DatosIngreso[llave] != 0 )
            camposLlenos++;
      });
      if(camposLlenos > 0)
        return true;
      else
        return false;
    },
    //Ajustes de tipado
    AjustarTiposDeDatos(){
      this.DatosSolicitudGeneral.producto = this.DatosSolicitudGeneral.producto != null ? parseInt(this.DatosSolicitudGeneral.producto) : null;
      this.DatosSolicitudGeneral.servicio = this.DatosSolicitudGeneral.servicio != null ? parseInt(this.DatosSolicitudGeneral.servicio) : null;
      this.DatosSolicitudGeneral.envioEstadoCuenta = this.DatosSolicitudGeneral.envioEstadoCuenta != null ? parseInt(this.DatosSolicitudGeneral.envioEstadoCuenta) : null;
      this.DatosSolicitudGeneral.enCasoAutorizacion = this.DatosSolicitudGeneral.enCasoAutorizacion != null ? parseInt(this.DatosSolicitudGeneral.enCasoAutorizacion) : null;

      this.DatosPersonaFisica.regimenMatrimonial = this.DatosPersonaFisica.regimenMatrimonial != null ? parseInt(this.DatosPersonaFisica.regimenMatrimonial) : null;
      this.DatosPersonaFisica.lugarNacimiento = this.DatosPersonaFisica.lugarNacimiento != null ? parseInt(this.DatosPersonaFisica.lugarNacimiento) : null;
      this.DatosPersonaFisica.sexo = this.DatosPersonaFisica.sexo != null ? parseInt(this.DatosPersonaFisica.sexo) : null;
      this.DatosPersonaFisica.tipoIdentificacion = this.DatosPersonaFisica.tipoIdentificacion != null ?  parseInt(this.DatosPersonaFisica.tipoIdentificacion) : null;
      this.DatosPersonaFisica.estadoCivil = this.DatosPersonaFisica.estadoCivil != null ?  parseInt(this.DatosPersonaFisica.estadoCivil) : null;
      this.DatosPersonaFisica.nacionalidad = this.DatosPersonaFisica.nacionalidad != null ? parseInt(this.DatosPersonaFisica.nacionalidad) : null;
      this.DatosPersonaFisica.tipoEmpleo = this.DatosPersonaFisica.tipoEmpleo != null ? parseInt(this.DatosPersonaFisica.tipoEmpleo) : null;
      this.DatosPersonaFisica.tipoVivienda = this.DatosPersonaFisica.tipoVivienda != null ? parseInt(this.DatosPersonaFisica.tipoVivienda) : null;
      this.DatosPersonaFisica.gradoEstudios = this.DatosPersonaFisica.gradoEstudios != null ? parseInt(this.DatosPersonaFisica.gradoEstudios) : null;
      this.DatosPersonaFisica.profesion = this.DatosPersonaFisica.profesion != null ?  parseInt(this.DatosPersonaFisica.profesion) : null;
      this.DatosPersonaFisica.numeroDependientes = this.DatosPersonaFisica.numeroDependientes != null ? parseInt(this.DatosPersonaFisica.numeroDependientes) : null;
      this.DatosPersonaFisica.egresoMensual = this.DatosPersonaFisica.egresoMensual != null ? parseInt(this.DatosPersonaFisica.egresoMensual) : null;

      this.PuntoContactoGeneral.telefonoFijo.valor = this.PuntoContactoGeneral.telefonoFijo.valor != null ?  this.PuntoContactoGeneral.telefonoFijo.valor.toString() : null;
      this.PuntoContactoGeneral.telefonoFijoOficina.valor = this.PuntoContactoGeneral.telefonoFijoOficina.valor != null ?  this.PuntoContactoGeneral.telefonoFijoOficina.valor.toString() : null;
      this.PuntoContactoGeneral.telefonoMovil.valor = this.PuntoContactoGeneral.telefonoMovil.valor != null ? this.PuntoContactoGeneral.telefonoMovil.valor.toString() : null;

      this.PuntoContactoConyuge.telefonoFijoConyuge.valor = this.PuntoContactoConyuge.telefonoFijoConyuge.valor != null ?  this.PuntoContactoConyuge.telefonoFijoConyuge.valor.toString() : null;
      this.PuntoContactoConyuge.correoConyuge.valor = this.PuntoContactoConyuge.correoConyuge.valor != null ?  this.PuntoContactoConyuge.correoConyuge.valor.toString() : null;
      this.PuntoContactoConyuge.telefonoMovilConyuge.valor = this.PuntoContactoConyuge.telefonoMovilConyuge.valor != null ? this.PuntoContactoConyuge.telefonoMovilConyuge.valor.toString() : null;

      this.DatosIngreso.tipoIngreso = this.DatosIngreso.tipoIngreso != null ?  parseInt(this.DatosIngreso.tipoIngreso) : null;
      this.DatosIngreso.divisa = this.DatosIngreso.divisa != null ?  parseInt(this.DatosIngreso.divisa) : null;
      if(isNaN(this.DatosIngreso.antiguedadAnios)){
        this.DatosIngreso.antiguedadAnios = null;
      } else {
        this.DatosIngreso.antiguedadAnios = this.DatosIngreso.antiguedadAnios != null ? parseInt(this.DatosIngreso.antiguedadAnios) : null;
      }


      this.DatosUbicacionParticular.paisId = this.DatosUbicacionParticular.paisId != null ? parseInt(this.DatosUbicacionParticular.paisId) : null;
      this.DatosUbicacionOficina.paisId = this.DatosUbicacionOficina.paisId != null ? parseInt(this.DatosUbicacionOficina.paisId) : null;

    }
  },
  watch: {
    'DatosIngreso.divisa': function () {
      if(this.DatosIngreso.divisa == 3){
        this.opcionesAutoNumeric = {
          currencySymbol : ' €',
          decimalCharacter : ',',
          digitGroupSeparator : '.',
          currencySymbolPlacement: 'p',
        }
      } else {
        this.opcionesAutoNumeric = {
          digitGroupSeparator: ',',
          decimalCharacter: '.',
          decimalCharacterAlternative: '.',
          currencySymbol: '$',
          currencySymbolPlacement: 'p',
          roundingMethod: 'U',
          minimumValue: '0',
          maximumValue: '15000000'
        }
      }
    },
    // 'DatosUbicacionParticular.codigoPostal' : function () {
    //   let zipCode =  this.DatosUbicacionParticular.codigoPostal.toString();
    //   if(zipCode.length > 10) {
    //     zipCode = zipCode.substring(0,9);
    //     this.DatosUbicacionParticular.codigoPostal = zipCode;
    //   }
    // },
    'DatosBeneficiario.porcentaje' : function () {
      this.DatosBeneficiario.porcentaje = servicios.EvitarNegativos(this.DatosBeneficiario.porcentaje);
      let sumaPrevia = parseInt(this.DatosBeneficiario.porcentaje) + this.sumaBeneficiarios;
      if(sumaPrevia > 100) {
        this.DatosBeneficiario.porcentaje = this.DatosBeneficiario.porcentaje - 1;
      }else {
        if(this.beneficiarios.length == 4) {
          if(this.sumaBeneficiarios + parseInt(this.DatosBeneficiario.porcentaje) < 100) {
            this.DatosBeneficiario.porcentaje = 100 - this.sumaBeneficiarios;
          }
        }
      }
      if(parseInt(this.DatosBeneficiario.porcentaje) > 100) {
        this.DatosBeneficiario.porcentaje = 100;
      }
    },
    FormReferencias: {
      handler : function (value) {
        value.forEach(item => {
          item.telefonoParticular = servicios.EvitarNegativos( item.telefonoParticular);
          item.telefonoMovil = servicios.EvitarNegativos( item.telefonoMovil);
          item.telefonoParticular = servicios.LimitarTelefonoLocal( item.telefonoParticular);
          item.telefonoMovil = servicios.LimitarTelefonoLocal( item.telefonoMovil);
        });
      },
      deep: true
    },
    FormBeneficiarios : {
      handler: function (value) {
        value.forEach(item => {
          item.porcentaje = item.porcentaje == "" ? 0 : Math.trunc(servicios.EvitarNegativos(item.porcentaje));
          item.telefono = servicios.LimitarTelefonoLocal(item.telefono);
        });
      },
      deep: true
    },
    'PuntoContactoConyuge.telefonoFijoConyuge.valor' : function() {
      this.PuntoContactoConyuge.telefonoFijoConyuge.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoConyuge.telefonoFijoConyuge.valor);
    },
    'PuntoContactoConyuge.telefonoMovilConyuge.valor' : function() {
      this.PuntoContactoConyuge.telefonoMovilConyuge.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoConyuge.telefonoMovilConyuge.valor);
    },
    'DatosReferencia.aniosRelacion' : function () {
      this.DatosReferencia.aniosRelacion = servicios.EvitarNegativos(this.DatosReferencia.aniosRelacion);
      if(this.DatosReferencia.aniosRelacion > 100)
        this.DatosReferencia.aniosRelacion = 100;
    },
    'DatosIngreso.antiguedadAnios' :function () {
      this.DatosIngreso.antiguedadAnios = servicios.EvitarNegativos(this.DatosIngreso.antiguedadAnios);
      if(this.DatosIngreso.antiguedadAnios > 65)
        this.DatosIngreso.antiguedadAnios = 65;
    },
    'DatosIngreso.antiguedadMeses' :function () {
      this.DatosIngreso.antiguedadMeses = servicios.EvitarNegativos(this.DatosIngreso.antiguedadMeses);
      if(this.DatosIngreso.antiguedadMeses > 12)
        this.DatosIngreso.antiguedadMeses = 12;
    },
    'DatosPersonaFisica.numeroDependientes': function () {
      this.DatosPersonaFisica.numeroDependientes = servicios.EvitarNegativos(this.DatosPersonaFisica.numeroDependientes);
      if(this.DatosPersonaFisica.numeroDependientes > 10)
        this.DatosPersonaFisica.numeroDependientes = 10;
    },
    'DatosSolicitudGeneral.fechaNacimiento' : function () {
      var fechaNacimiento = new Date(
        this.DatosSolicitudGeneral.fechaNacimiento
      );
      this.esMayorDeEdad = servicios.EsMayorDeEdad(fechaNacimiento);
    },
    'PuntoContactoGeneral.telefonoFijo.valor' : function () {
      this.PuntoContactoGeneral.telefonoFijo.valor = servicios.EvitarNegativos(this.PuntoContactoGeneral.telefonoFijo.valor);
      this.PuntoContactoGeneral.telefonoFijo.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoFijo.valor);
    },
    'PuntoContactoGeneral.telefonoMovil.valor' : function () {
      this.PuntoContactoGeneral.telefonoMovil.valor = servicios.EvitarNegativos(this.PuntoContactoGeneral.telefonoMovil.valor);
      this.PuntoContactoGeneral.telefonoMovil.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoMovil.valor);
    },
    'PuntoContactoGeneral.telefonoFijoOficina.valor' : function () {
      this.PuntoContactoGeneral.telefonoFijoOficina.valor = servicios.EvitarNegativos(this.PuntoContactoGeneral.telefonoFijoOficina.valor);
      this.PuntoContactoGeneral.telefonoFijoOficina.valor = servicios.LimitarTelefonoLocal(this.PuntoContactoGeneral.telefonoFijoOficina.valor);
    },
  }

}
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
//import { Identificacion } from '../../../../../servicios/api';
.form-group {
  margin-bottom: -15px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/**Remover iconos en los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
